export default function interstitialCode(siteId, widgetId, widget) {
  const { type, interstitial } = widget
  if (interstitial !== undefined && interstitial.active) {
    return `<script defer src="//phoenix-widget.com/static/js/interstitial.js?site_id=${siteId}&widget_id=${widgetId}&type=${type}&time=${interstitial.time}&page_count=${interstitial.page_count}"><${''}/script>`
  }
  return ''
}
